export default { version: '4.0.0' }
